import $ from 'jquery'

var SophiaNamespace = SOPHIA,
    $messagePopup,
    $messagePopupInner;

SophiaNamespace.flashMessage = function(message, type) {
  // Container
  $messagePopup = $('<div class="flash-message-popup"></div>'),
  // Set class related to popup-type
  $messagePopup.addClass('flash-message-popup__' + type);

  // Inner Area with display: table-cell
  $messagePopupInner = $('<div class="flash-message-popup__inner"></div>');
  $messagePopup.append( $messagePopupInner );

  // Close Button
  $messagePopup.append( '<a href="#" class="flash-message-popup__close" title="Close Message"></a>' );

  $messagePopupInner.html( message );

  // Append Popup to Body
  setTimeout(function() {
    removePrevFlash();
    $('body').prepend( $messagePopup );

    $messagePopup.on('click', '.flash-message-popup__close', closeFlashPopup);
    $messagePopup.on('blur', '.flash-message-popup__close', closeFlashPopup);

    $messagePopup.animate({ top: 95 }, 600, 'easeInOutCubic', function() {
      $('body, html').animate({ scrollTop: 0 });
    });

    updateFlashPosition();

    // Update Position on window.resize
    $(window).on('resize', updateFlashPosition);
    $(window).on('keyup', function(e) {
      if (e.keyCode == $.ui.keyCode.ESCAPE) {
        closeFlashPopup(e);
      }
    });

  }, 600);
}

var closeFlashPopup = SophiaNamespace.closeFlashPopup = function(event) {
   if (event) { event.preventDefault(); }

  // Off all binded events
  $(window).off('keyup');
  if ($messagePopup) {
    $messagePopup.off('blur', '.flash-message-popup__close');
  }

  $('.flash-message-popup').last().fadeOut(function() { $(this).remove() })
}

function updateFlashPosition() {
  var windowWidth = $(window).width(),
      popupWidth = $messagePopup.outerWidth(),
      left;

  left = (windowWidth - popupWidth) / 2

  $messagePopup.css('left', left);
}

function removePrevFlash() {
  var prevFlash = $('.flash-message-popup')
  if (prevFlash.length) {
    prevFlash.remove();
  }
}
